//LIBRARIES
import React, { Fragment } from 'react';
import { Formik, yupToFormErrors } from 'formik';
import * as Yup from 'yup';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

//COMPONENTS
import PersonalDetails from './TenantDetailsSection/PersonalDetails';
import EmergencyContact from './TenantDetailsSection/EmergencyContact';
import Row from 'components/ui/Row';
import { VerticalFormWrapper } from 'components/ui/VerticalFormWrapper';

//HELPERS
import { getTranslatedString } from 'helpers/i18n';
import { isValidEmail, validUniqueLeadEmail } from 'helpers/Validator';

const requiredErrorVerbiage = getTranslatedString('required');
const invalidPhoneVerbiage = getTranslatedString('validationErrors.invalidPhone');
const invalidEmailVerbiage = getTranslatedString('invalidEmail');
const invalidFullNameVerbiage = getTranslatedString('fullNameValidation');

const TenantDetailsForm = ({ onSubmit, initialValues, formName, enableSubmit, isUserAdmin }) => {
  const validationSchema = {
    first_name: Yup.string().required(requiredErrorVerbiage),
    last_name: Yup.string().required(requiredErrorVerbiage),
    phone_number: Yup.string()
      .required(requiredErrorVerbiage)
      .test('phone_number', invalidPhoneVerbiage, function (value) {
        if (!value) return false;
        if (value.replace(/\s/g, '') === '+00000000000') return true;
        const parseResult = parsePhoneNumberFromString(value);
        return parseResult && parseResult.isValid();
      }),
    email: Yup.string()
      .required(requiredErrorVerbiage)
      .test('email', invalidEmailVerbiage, async function (value) {
        return await validUniqueLeadEmail(value, initialValues.lead_id);
      }),
    emergency_contacts: Yup.array().of(
      Yup.object().shape({
        full_name: Yup.string()
          .required(requiredErrorVerbiage)
          .test('full_name', invalidFullNameVerbiage, function (value) {
            return value.trim().indexOf(' ') !== -1;
          }),
        phone_number: Yup.string()
          .required(requiredErrorVerbiage)
          .test('phone_number', invalidPhoneVerbiage, function (value) {
            if (!value) return false;
            if (value.replace(/\s/g, '') === '+00000000000') return true;
            const parseResult = parsePhoneNumberFromString(value);
            return parseResult && parseResult.isValid();
          }),
        email: Yup.string()
          .nullable()
          .test('email', invalidEmailVerbiage, function (value) {
            return isValidEmail(value);
          }),
        relationship: Yup.string().required(requiredErrorVerbiage),
      })
    ),
  };

  const validateForm = async (values) => {
    const schema = Yup.object().shape(validationSchema);
    enableSubmit();
    return schema.validate(values, { abortEarly: false }).catch((error) => {
      throw yupToFormErrors(error);
    });
  };
  return (
    <Fragment>
      <Row style={{ marginBottom: '12px' }}>
        <span>{getTranslatedString('landlordPortal.events.requiredField')}</span>
      </Row>
      <Formik initialValues={initialValues} onSubmit={onSubmit} validate={validateForm}>
        {({ handleSubmit, ...rest }) => (
          <VerticalFormWrapper id={formName} onSubmit={handleSubmit}>
            <PersonalDetails isUserAdmin={isUserAdmin} {...rest} />
            <EmergencyContact {...rest} />
          </VerticalFormWrapper>
        )}
      </Formik>
    </Fragment>
  );
};

export default TenantDetailsForm;
